import { defineStore } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import { post } from '@/common/request'
import { url } from '@/common/config'

export const useMillionStore = defineStore('million', {
  state: () => {
    return {
      ccc: ''
    }
  },
  getters: {
    country() {
      return useUserStore().country
    }
  },
  actions: {
    global() {
      return post(url.Million.global)
    },
    spinRequest(query) {
      return post(url.Million.spin, query)
    },
    cost() {
      return post(url.Million.cost)
    },
    myCode() {
      return post(url.Million.myCode)
    },
    winnerRrcord(query) {
      return post(url.Million.rewards, query)
    },
    record(query) {
      return post(url.Million.record, query)
    },
    history(query) {
      return post(url.Million.history, query)
    }
  }
})
